const config={
  about: {
    getApi: '/data/about',
    intro:{
      travel:"トラトラ（TRAVEL & TRAVEL PTY. LIMITED.）はオーストラリア旅行業界 「AFTA」加盟の旅行代理店です。トラトラのシドニーオフィスとオンラインで旅行の手配を受け付けています。\n\nトラトラには旅行のスペシャリストのスタッフが随時常駐。\nお客様のオーストラリア国内旅行、日帰りツアー、各種航空券手配などのサポートをさせていただいております。\n\nその他、オーストラリアをまわるバックパッカーのラウンド相談や、家族旅行のお見積もり、日本行き格安航空券の手配など幅広くご相談いただけます。",
      mobile:""
    }
  },
};

export default config;


// WEBPACK FOOTER //
// ./src/pages/about/config/config.js